import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=5b2aa96b&scoped=true"
import script from "./AppToolbar.vue?vue&type=script&lang=js"
export * from "./AppToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2aa96b",
  null
  
)

export default component.exports